module.exports = __webpack_public_path__ + "static/media/t20-wc-icon.bd327a66.jpg";